/**
 * ROOM UPLOADS ALLOWLIST (CONTEXT-DOCS.md §P0) — the client half of the door check: refuse a file we can't turn into
 * context BEFORE uploading it, with the reason. The list + cap are GENERATED from the backend (generatedUploadTypes);
 * the upload-URL route enforces the same (415).
 */
import { ROOM_UPLOAD_EXTENSIONS, ROOM_UPLOAD_MAX_BYTES } from '../services/generatedUploadTypes';

export { ROOM_UPLOAD_ACCEPT, ROOM_UPLOAD_EXTENSIONS, ROOM_UPLOAD_MAX_BYTES } from '../services/generatedUploadTypes';

const _mb = (n) => `${Math.round(n / (1024 * 1024))} MB`;

/** '' when the file may be shared, else a one-line human reason. Pure. */
export function roomUploadRejection(file) {
  const name = String((file && file.name) || '').trim();
  const lower = name.toLowerCase();
  if (!name) return 'This file has no name.';
  if (!ROOM_UPLOAD_EXTENSIONS.some((e) => lower.endsWith(e))) {
    const ext = lower.includes('.') ? `.${lower.split('.').pop()}` : 'files without an extension';
    const legacy = { '.doc': '.docx', '.xls': '.xlsx', '.ppt': '.pptx' }[ext];
    return legacy
      ? `${ext} can't be read — save it as ${legacy} and share it again.`
      : `StepFlow can't read ${ext} into the context.`;
  }
  if (Number(file.size) > ROOM_UPLOAD_MAX_BYTES) return `Too big — the limit is ${_mb(ROOM_UPLOAD_MAX_BYTES)}.`;
  return '';
}
